/**
 * @desc ToB客户信息-详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.BusinessCustomerDetailResponseDto>;
export function request(customerCode: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/businessCustomer/detail/${customerCode}`, {
      method: "GET",

      ...options,
    }),
  );
}
